<template>
    <b-modal ref="mdlConfigurazionePianificazione" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Presidio</label>
                <b-form-select v-model="jsonData.idPresidio" :options="presidioOptions" value-field="id" text-field="denominazione" @change="onChangePresidio">
                    <template #first>
                        <b-form-select-option :value="null"> - Seleziona Presidio - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Diario</label>
                <b-form-select v-model="jsonData.idDiario" :options="diarioOptions" value-field="id" text-field="nome" required>
                    <template #first>
                        <b-form-select-option :value="null"> - Seleziona Diario - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Numero Ripetizioni</label>
                <b-form-input type="number" v-model="jsonData.ripetizioni" disabled></b-form-input>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-3">
                <label class="sa-label-data">Frequenza </label>
                <b-form-select v-model="tempFrequenza" :options="frequenzaOptions" value-field="value" text-field="text" @change="onAddFrequenza">
                    <template #first>
                        <b-form-select-option :value="null"> - Seleziona Turno - </b-form-select-option>
                    </template>
                </b-form-select>

                <b-input-group class="mb-2">
                    <div class="d-flex flex-wrap">
                        <b-card v-for="tag in listaFrequenze" :key="tag" class="mt-1 mr-1" body-class="py-1 pr-2 text-nowrap" style="padding-top: 1px">
                            <span class="mr-2">{{ tag }}</span>
                            <b-button @click="removeFrequenza(tag)" variant="link" size="sm" class="p-0 text-danger" style="line-height: 1">
                                <b-icon icon="x-circle-fill"></b-icon>
                            </b-button>
                        </b-card>
                    </div>
                </b-input-group>
            </b-col>
        </b-row>

        <template #modal-footer>
            <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button variant="outline-success" @click="onClickSave()">Salva</b-button>
        </template>

        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

export default {
    name: "ModalConfigurazionePianificazione",
    mixins: [UtilityMixin],
    components: {
        ModalError,
    },

    data() {
        return {
            pathResource: "/rsaparametrivitalipianificazione",
            pathResourceDiari: "/rsadiari",
            pathResourcePresidi: "/strutturepresidi",
            pathResourceTurni: "/rsaconfigurazioneturni",
            id: null,
            title: null,
            tempFrequenza: null,
            listaFrequenze: [],
            jsonData: {
                id: null,
                idPresidio: null,
                idDiario: null,
                frequenza: null,
                ripetizioni: 0,
            },
            presidioOptions: [],
            diarioOptions: [],
            frequenzaOptions: [], // Ora popolata da DB
        };
    },

    methods: {
        setId(id) {
            let me = this;
            me.id = id;
            me.listaFrequenze = [];
            me.tempFrequenza = null;

            // Caricamento opzioni iniziali
            me.loadPresidi();
            me.loadTurni();

            if (id === null) {
                me.title = "Nuova Pianificazione";
                me.jsonData = {
                    id: null,
                    idPresidio: null,
                    idDiario: null,
                    frequenza: null,
                    ripetizioni: 0,
                };
            } else {
                me.title = "Modifica Pianificazione";
                me.loadData();
            }

            me.$refs.mdlConfigurazionePianificazione.show();
        },

        loadData() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            UtilityMixin.methods.restCallGet(
                path,
                null,
                (response) => {
                    me.jsonData = response.data.data;
                    if (me.jsonData.frequenza) {
                        me.listaFrequenze = me.jsonData.frequenza.split(",").map((s) => s.trim());
                    }
                    if (me.jsonData.idPresidio) me.loadDiari();
                },
                (error) => {
                    console.error("Errore caricamento dati", error);
                },
            );
        },

        loadPresidi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, null, (response) => {
                me.presidioOptions = response.data.data?.list || response.data.data;
            });
        },

        loadTurni() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTurni, {}, me.loadTurniSuccess, me.loadTurniError);
        },
        loadTurniSuccess(response) {
            let me = this;
            me.frequenzaOptions = [];
            response.data.data.list.forEach((element) => {
                me.frequenzaOptions.push({ text: element.label, value: element.label });
            });
        },
        loadTurniError(error) {
            error;
        },

        onChangePresidio() {
            this.jsonData.idDiario = null;
            this.loadDiari();
        },

        loadDiari() {
            let me = this;
            if (!me.jsonData.idPresidio) return;
            UtilityMixin.methods.loadDataResources(me.pathResourceDiari, { idPresidio: me.jsonData.idPresidio }, (response) => {
                me.diarioOptions = response.data.data?.list || response.data.data;
            });
        },

        onAddFrequenza(value) {
            if (value && !this.listaFrequenze.includes(value)) {
                this.listaFrequenze.push(value);
                this.jsonData.ripetizioni = this.listaFrequenze.length;
            }
            this.$nextTick(() => {
                this.tempFrequenza = null;
            });
        },

        removeFrequenza(tag) {
            this.listaFrequenze = this.listaFrequenze.filter((t) => t !== tag);
            this.jsonData.ripetizioni = this.listaFrequenze.length;
        },

        onClickSave() {
            let me = this;
            me.jsonData.frequenza = me.listaFrequenze.join(", ");

            if (!me.jsonData.idPresidio || !me.jsonData.idDiario || me.listaFrequenze.length === 0) {
                me.$refs.cmpModalError.show("Tutti i campi (inclusa almeno una frequenza) sono obbligatori");
                return;
            }

            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.saveSuccess, me.saveError);
        },

        saveSuccess(response) {
            this.$emit("onSave", response);
            this.$refs.mdlConfigurazionePianificazione.hide();
            this.$bvToast.toast("Salvataggio completato", { variant: "success", solid: true });
        },

        saveError(error) {
            const msg = error.response?.data?.messaggio || "Errore nel salvataggio";
            this.$refs.cmpModalError.show(msg);
        },

        onCloseModal() {
            this.$refs.mdlConfigurazionePianificazione.hide();
            this.$emit("onCloseModal");
        },

        // Metodi Delete mantenuti come da tua versione
        onDeleteParametroVitale(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo parametro vitale?", {
                    title: "Eliminazione",
                    okVariant: "danger",
                    centered: true,
                })
                .then((value) => {
                    if (value) me.deleteParametroVitale(item.id);
                });
        },

        deleteParametroVitale(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, me.jsonData, me.onDeleteParametroVitaleSuccess, me.onDeleteParametroVitaleError);
        },

        onDeleteParametroVitaleSuccess(response) {
            this.$emit("deleteParametroVitale", response);
            this.$bvToast.toast("Eliminazione avvenuta", { variant: "success" });
        },

        onDeleteParametroVitaleError(response) {
            response;
            this.$bvToast.toast("Errore eliminazione", { variant: "danger" });
        },
    },
};
</script>
